module.exports = __webpack_public_path__ + "img/1.55110aed.svg";